import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { PublicClientApplication } from '@azure/msal-browser';
import axios from 'axios';
import { ThemeProvider, createTheme } from '@mui/material/styles';

//create theme
const theme = createTheme({
  typography:{
    fontFamily:  `"open-sans",sans-serif`
  },
  palette:{
    // primary: "#00664F",
    secondary: {
      main:"#FED141"
    },

  }
})

//msal-instance initialization
const pca = new PublicClientApplication({
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID,
    authority: "https://login.microsoftonline.com/5b2a8fee-4c95-4bdc-8aae-196f8aacb1b6",
    // Prefer an explicit env var; fall back to the current origin when not provided
    redirectUri: process.env.REACT_APP_REDIRECT_URI || window.location.origin
  }
})

//axios defaults and interceptor initialization
axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;
axios.interceptors.request.use(req =>{
  req.headers.Authorization = `Bearer ${localStorage.getItem('token')}`
  return req
})

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render( 
    <ThemeProvider theme={theme}>
      <App msalInstance={pca} />
    </ThemeProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
